module.exports = __webpack_public_path__ + "static/media/BROCHURER&A2019.e68e3f25.pdf";